module.exports = __webpack_public_path__ + "img/flot-fyr-paa-snap-4.391cf8eb.png";